// Black Friday Cookie Check and Redirect
(function() {
    'use strict';
    
    // Function to get cookie value
    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    
    // Check if we're already on the Black Friday collection page to avoid infinite redirects
    function isOnBlackFridayPage() {
        return window.location.href.includes('/collections/black-friday-2025');
    }
    
    // Main function to check cookie and redirect
    function checkBFCookieAndRedirect() {
        const cookieName = 'bf_collection_viewed';
        const cookieValue = getCookie(cookieName);
        
        // Only redirect if cookie doesn't exist AND we're not already on the BF page
        if (!cookieValue && !isOnBlackFridayPage()) {
            console.log('BF collection cookie not found - redirecting to Black Friday page');
            window.location.href = 'https://peaktoys.ro/collections/black-friday-2025';
        } else if (cookieValue) {
            console.log('BF collection cookie found - user has already visited Black Friday page');
        } else {
            console.log('Already on Black Friday collection page - no redirect needed');
        }
    }
    
    // Run the check when DOM is loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkBFCookieAndRedirect);
    } else {
        checkBFCookieAndRedirect();
    }
    
})();